import { render, staticRenderFns } from "./ModalVault.vue?vue&type=template&id=16c3d52e&scoped=true"
import script from "./ModalVault.vue?vue&type=script&lang=js"
export * from "./ModalVault.vue?vue&type=script&lang=js"
import style0 from "./ModalVault.vue?vue&type=style&index=0&id=16c3d52e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c3d52e",
  null
  
)

export default component.exports